import solicitudes_comprar from 'views/pro/cotizar/solicitudes_por_comprar_invitado.vue';

new Vue({
    el: '#app_compra_solicitudes',
    components: {
        'solicitudes-comprar': solicitudes_comprar
    }
});
